<form class="flex grow flex-col gap-4" [formGroup]="formGroup">
  <mat-form-field subscriptSizing="dynamic">
    <mat-label>Comparison</mat-label>
    <mat-select formControlName="comparison" required>
      @for (comparison of comparisons; track comparison) {
        <mat-option [value]="comparison.value">
          {{ comparison.label }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field subscriptSizing="dynamic">
    <mat-label>
      {{ propertyLabel() }}
      {{
        formGroup.value.comparison | map: getComparisonLabel : this | lowercase
      }}
      any of
    </mat-label>
    <mat-chip-grid #chipGrid [formControl]="valueCtrl">
      @for (value of formGroup.value.values; track value) {
        <mat-chip-row (removed)="remove(value)">
          {{ value }}
          <button matChipRemove>
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
      }
    </mat-chip-grid>
    <input
      placeholder="Add a {{ propertyLabel() }}"
      [matChipInputFor]="chipGrid"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [matChipInputAddOnBlur]="true"
      (matChipInputTokenEnd)="add($event)"
    />

    @switch (formatter().formatter) {
      @case ('prefix') {
        <span matTextPrefix>{{ formatter().prefix }}&nbsp;</span>
      }
      @case ('suffix') {
        <span matTextSuffix>&nbsp;{{ formatter().suffix }}</span>
      }
    }

    <mat-hint>
      @if (comparisonHint$ | async; as comparisonHint) {
        {{ comparisonHint }}
      }
      Press Enter or comma to add multiple values.
    </mat-hint>
  </mat-form-field>
</form>
